// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "diagnostics-screen" + "." + "223e9904" + ".css";
};